import GATEWAYS from 'constants/TransactionGateways';

export const findGatewayNameByCode = (gateway_code: string) => {
  return GATEWAYS.find((gateway) => gateway.gateway_code === gateway_code)?.name;
};
